import { render, staticRenderFns } from "./MeetingTypeAssignRoleTable.vue?vue&type=template&id=0bd9b9e7&scoped=true&"
import script from "./MeetingTypeAssignRoleTable.vue?vue&type=script&lang=js&"
export * from "./MeetingTypeAssignRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9b9e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
